import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["container", "backdrop", "panel", "content", "title", "loading"]
  static values = { url: String }

  connect() {
    this.closeOnEscape = this.closeOnEscape.bind(this)
  }

  async open(event) {
    event.preventDefault()
    
    const url = event.currentTarget.dataset.previewUrl
    const title = event.currentTarget.dataset.previewTitle || "Preview"
    
    // Show modal with loading state
    this.titleTarget.textContent = title
    this.contentTarget.innerHTML = ""
    this.loadingTarget.classList.remove("hidden")
    this.containerTarget.classList.remove("hidden")
    
    // Trigger animations
    requestAnimationFrame(() => {
      this.backdropTarget.classList.remove("opacity-0")
      this.backdropTarget.classList.add("opacity-100")
      this.panelTarget.classList.remove("opacity-0", "translate-y-4", "sm:translate-y-0", "sm:scale-95")
      this.panelTarget.classList.add("opacity-100", "translate-y-0", "sm:scale-100")
    })
    
    document.body.classList.add("overflow-hidden")
    document.addEventListener("keydown", this.closeOnEscape)
    
    // Fetch content
    try {
      const response = await fetch(url, {
        headers: {
          "Accept": "text/html",
          "X-Requested-With": "XMLHttpRequest"
        }
      })
      
      if (response.ok) {
        const html = await response.text()
        this.contentTarget.innerHTML = html
      } else {
        this.contentTarget.innerHTML = '<p class="text-red-500">Failed to load preview.</p>'
      }
    } catch (error) {
      this.contentTarget.innerHTML = '<p class="text-red-500">Failed to load preview.</p>'
    } finally {
      this.loadingTarget.classList.add("hidden")
    }
  }

  close() {
    this.backdropTarget.classList.remove("opacity-100")
    this.backdropTarget.classList.add("opacity-0")
    this.panelTarget.classList.remove("opacity-100", "translate-y-0", "sm:scale-100")
    this.panelTarget.classList.add("opacity-0", "translate-y-4", "sm:translate-y-0", "sm:scale-95")
    
    setTimeout(() => {
      this.containerTarget.classList.add("hidden")
    }, 200)
    
    document.body.classList.remove("overflow-hidden")
    document.removeEventListener("keydown", this.closeOnEscape)
  }

  closeOnEscape(event) {
    if (event.key === "Escape") {
      this.close()
    }
  }

  closeOnBackdrop(event) {
    if (event.target === this.backdropTarget) {
      this.close()
    }
  }

  disconnect() {
    document.removeEventListener("keydown", this.closeOnEscape)
    document.body.classList.remove("overflow-hidden")
  }
}
